/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EnglishInputs */

const de_english = /** @type {(inputs: EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

/** @type {(inputs: EnglishInputs) => LocalizedString} */
const en_english = () => /** @type {LocalizedString} */ ('english')

/**

* @param {EnglishInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const english = /** @type {((inputs?: EnglishInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EnglishInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_english(inputs)
	return en_english(inputs)
});